<template>
  <div class="menu" :class="{ 'menu-active': !showDropdown }">
    <RouterLink :to="{ name: 'home.index' }" class="menu-item">
      {{ t('main.menu.home.text') }}
    </RouterLink>

    <div class="menu-item group">
      <div class="menu-item-title">
        {{ t('main.menu.products.text') }}
        <i class="bi bi-chevron-down"></i>
      </div>

      <div class="submenu">
        <div class="submenu-container">
          <RouterLink :to="{ name: 'products.page' }" class="submenu-item">
            <span class="">{{ t('main.menu.products.submenu.page.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.products.submenu.page.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'products.webshop' }" class="submenu-item">
            <span class="">{{ t('main.menu.products.submenu.webshop.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.products.submenu.webshop.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'products.pos' }" class="submenu-item">
            <span class="">{{ t('main.menu.products.submenu.pos.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.products.submenu.pos.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'products.kiosk' }" class="submenu-item">
            <span class="">{{ t('main.menu.products.submenu.kiosk.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.products.submenu.kiosk.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'products.qr' }" class="submenu-item">
            <span class="">{{ t('main.menu.products.submenu.qr.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.products.submenu.qr.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'products.posdevice' }" class="submenu-item">
            <span class="">{{ t('main.menu.products.submenu.posdevice.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.products.submenu.posdevice.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'products.manager' }" class="submenu-item">
            <span class="">{{ t('main.menu.products.submenu.manager.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.products.submenu.manager.subtext')
            }}</span>
          </RouterLink>
        </div>
      </div>
    </div>

    <RouterLink :to="{ name: 'pricing.index' }" class="menu-item">
      {{ t('main.menu.prices.text') }}
    </RouterLink>

    <div class="menu-item group">
      <div class="menu-item-title">
        {{ t('main.menu.cases.text') }}
        <i class="bi bi-chevron-down"></i>
      </div>

      <div class="submenu">
        <div class="submenu-container">
          <RouterLink :to="{ name: 'cases.lunchroom' }" class="submenu-item">
            <span class="">{{ t('main.menu.cases.submenu.lunchroom.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.cases.submenu.lunchroom.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'cases.grillroom' }" class="submenu-item">
            <span class="">{{ t('main.menu.cases.submenu.grillroom.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.cases.submenu.grillroom.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'cases.sushi' }" class="submenu-item">
            <span class="">{{ t('main.menu.cases.submenu.sushi.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.cases.submenu.sushi.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'cases.italian' }" class="submenu-item">
            <span class="">{{ t('main.menu.cases.submenu.italian.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.cases.submenu.italian.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'cases.cafetaria' }" class="submenu-item">
            <span class="">{{ t('main.menu.cases.submenu.cafetaria.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.cases.submenu.cafetaria.subtext')
            }}</span>
          </RouterLink>
        </div>
      </div>
    </div>

    <div class="menu-item group">
      <div class="menu-item-title">
        Info
        <i class="bi bi-chevron-down"></i>
      </div>

      <div class="submenu">
        <div class="submenu-container">
          <a
            href="https://support.bistroo.com"
            rel="noopener noreferrer"
            target="_blank"
            class="submenu-item">
            <span class="">{{ t('main.menu.info.submenu.helpcenter.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.info.submenu.helpcenter.subtext')
            }}</span>
          </a>
          <RouterLink :to="{ name: 'info.integrations' }" class="submenu-item">
            <span class="">{{ t('main.menu.info.submenu.integrations.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.info.submenu.integrations.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'info.support' }" class="submenu-item">
            <span class="">{{ t('main.menu.info.submenu.support.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.info.submenu.support.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'info.downloads' }" class="submenu-item">
            <span class="">{{ t('main.menu.info.submenu.downloads.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.info.submenu.downloads.subtext')
            }}</span>
          </RouterLink>
          <RouterLink :to="{ name: 'info.faq' }" class="submenu-item">
            <span class="">{{ t('main.menu.info.submenu.faq.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.info.submenu.faq.subtext')
            }}</span>
          </RouterLink>
          <!-- <a
            href="https://www.bistroo.nl/blog"
            rel="noopener noreferrer"
            target="_blank"
            class="submenu-item">
            <span class="">{{ t('main.menu.info.submenu.blog.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.info.submenu.blog.subtext')
            }}</span>
          </a>-->
          <RouterLink :to="{ name: 'blogs.index' }" class="submenu-item">
            <span class="">{{ t('main.menu.info.submenu.blog.text') }}</span>
            <span class="font-medium text-xs text-lighter">{{
              t('main.menu.info.submenu.blog.subtext')
            }}</span>
          </RouterLink>
        </div>
      </div>
    </div>

    <a href="https://merchant.bistroo.nl/login" target="_blank" class="menu-item mt-6 md:!hidden">
      {{ t('main.login_text_mobile') }}
    </a>
  </div>
</template>

<script setup lang="ts">
/**
 * TODO: The parent link of a subcontainer should be clickable, for mobile it should collapse the submenu but for
 * desktop it should immediately navigate to the configured URL.
 *
 * We can do this by watching the window width but this breaks the tailwind design system.
 *
 * Probably need to check the event on whether it is a mouse click or touch action.
 *
 *
 * TODO: The current implementation does not respect SEO, we use divs to ensure SSR rendering won't break the anchor
 * contents, but bots won't understand this. Probably use some role value (role="navigation").
 */

import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

withDefaults(
  defineProps<{
    showDropdown?: boolean
  }>(),
  {
    showDropdown: false,
  }
)

onMounted(() => {
  const elements = document.querySelectorAll('.menu-item>.submenu')

  elements.forEach((el) => {
    if (!el.parentElement) {
      return
    }

    el.parentElement.addEventListener('click', () => {
      const isCollapsed = el.classList.contains('submenu-visible')

      // Hide all currently collapsed submenus
      document.querySelectorAll('.submenu-visible').forEach((el) => {
        el.classList.remove('submenu-visible')
      })

      // Collapse the clicked submenu
      el.classList.toggle('submenu-visible', !isCollapsed)
    })
  })
})
</script>

<style scoped>
@reference "@/assets/css/main.css";

.menu {
  @apply absolute z-[-1] top-full left-0 right-0 max-md:h-[100vh] max-lg:p-6 lg:ml-[154px] max-lg:bg-white lg:relative lg:w-full flex flex-col lg:flex-row lg:items-center lg:justify-center gap-4 lg:gap-8 transition-all ease-in-out;

  &.menu-active {
    @apply max-lg:-translate-y-full max-lg:opacity-0 max-lg:pointer-events-none;
  }

  .menu-item {
    @apply flex flex-col max-md:font-semibold lg:font-bold relative cursor-pointer max-md:border-b max-md:border-light max-md:pb-4;

    .menu-item-title {
      @apply flex gap-x-2 max-lg:justify-between max-lg:items-center w-full;
    }

    .submenu {
      @apply max-lg:hidden max-lg:p-4 lg:opacity-0 lg:-z-10 lg:group-hover:z-20 lg:pointer-events-none lg:group-hover:pointer-events-auto lg:group-hover:opacity-100 lg:absolute top-12.5 left-0 lg:bg-white lg:p-6 z-50 lg:min-w-max lg:rounded-lg lg:drop-shadow transition-all ease-in-out;

      &::before {
        @apply content-[''] hidden lg:block absolute -top-2 -translate-y-6 left-0 w-full h-12.5;
      }

      &.submenu-visible {
        @apply max-lg:flex flex-col max-h-none;
      }

      .submenu-container {
        @apply flex flex-col lg:grid lg:grid-cols-2 lg:whitespace-nowrap lg:gap-4 lg:gap-x-10 max-md:pt-4;

        .submenu-item {
          @apply flex flex-col lg:font-semibold max-md:pb-4;
        }
      }
    }
  }
}
</style>
